__turbopack_context__.v({
  "badge": "styles-module-scss-module__pT7nOW__badge",
});
